import m from "mithril"

export var state = {
  projects: [],
  settings: {},
  categoryLabels: {},
  loading: true,

  // portfolio filters
  activeCategory: "all",
  activeYear: "all",
  sortOrder: "desc",
  mobileNavOpen: false,

  // editor
  selectedProjectId: null,
  editorView: "empty", // "empty" | "project" | "settings"
}

export function loadData() {
  return m.request({
    method: "GET",
    url: "data/projects.json",
  }).then(function (data) {
    if (Array.isArray(data)) {
      state.projects = data
      state.settings = {}
    } else {
      state.projects = data.projects || []
      state.settings = data.settings || {}
    }
    rebuildCategoryLabels()
    state.loading = false
  }).catch(function (err) {
    console.error("Failed to load projects:", err)
    state.loading = false
  })
}

export function rebuildCategoryLabels() {
  state.categoryLabels = {}
  if (state.settings.filterCategories && Array.isArray(state.settings.filterCategories)) {
    state.settings.filterCategories.forEach(function (cat) {
      state.categoryLabels[cat.id] = cat.label
    })
  } else {
    state.categoryLabels = {
      branding: "Branding",
      web: "Web Design",
      illustration: "Illustration",
      animation: "Animation",
      print: "Print",
      experiment: "Experiments"
    }
  }
}

export function getFilteredProjects() {
  var filtered = state.projects.slice()

  if (state.activeCategory !== "all") {
    filtered = filtered.filter(function (p) {
      return p.category === state.activeCategory
    })
  }

  if (state.activeYear !== "all") {
    filtered = filtered.filter(function (p) {
      return p.year === parseInt(state.activeYear)
    })
  }

  filtered.sort(function (a, b) {
    return state.sortOrder === "desc" ? b.year - a.year : a.year - b.year
  })

  return filtered
}

export function getProjectById(id) {
  return state.projects.find(function (p) {
    return p.id === parseInt(id)
  })
}

export function getYouTubeEmbedUrl(url) {
  var videoId = ""
  try {
    var u = new URL(url)
    if (u.hostname.includes("youtu.be")) {
      videoId = u.pathname.slice(1)
    } else {
      videoId = u.searchParams.get("v") || ""
    }
  } catch (e) {
    videoId = url
  }
  return "https://www.youtube.com/embed/" + videoId
}
